// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.row {
  display: flex;
  justify-content: space-around;
}

/* Styles for the table */
table {
  border-collapse: collapse;
  width: 100%;
}

table, th, td {
  border: 0.25px solid black;
  padding: 0.25px;
}

mat-card {
  min-width: 280px;
  text-align: center;
  margin: 16px;
}

mat-card-title {
  background-color: rgb(238, 70, 81);
  color: white;
}

/* Optional: Style the buttons to be centered */
mat-card-actions {
  justify-content: center;
  align-items: center;
  display: flex;
}

mat-card-content {
  margin-top: 8px;
}

button[mat-raised-button] {
  background-color: rgb(238, 70, 81);
  color: white;
}

button[mat-stroked-button] {
  margin-right: 12px;
}

button[mat-raised-button]:hover {
  background-color: rgb(238, 70, 81);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.24), 0 0 1px rgba(0, 0, 0, 0.24);
}

button[mat-raised-button][disabled] {
  background-color: #e0e0e0;
  color: #9e9e9e;
  box-shadow: none;
}`, "",{"version":3,"sources":["webpack://./src/app/orders/invoicev2/invoice-due-card/invoice-due-card.component.scss","webpack://./src/scss/_variables.scss"],"names":[],"mappings":"AACA;EACI,aAAA;EACA,6BAAA;AAAJ;;AAGA,yBAAA;AACA;EACI,yBAAA;EACA,WAAA;AAAJ;;AAIE;EACE,0BAAA;EACA,eAAA;AADJ;;AAKA;EACI,gBAAA;EACA,kBAAA;EACA,YAAA;AAFJ;;AAME;EACE,kCCrBY;EDsBZ,YCxBa;ADqBjB;;AAME,+CAAA;AACA;EACE,uBAAA;EACA,mBAAA;EACA,aAAA;AAHJ;;AAME;EACE,eAAA;AAHJ;;AAME;EACE,kCCrCY;EDsCZ,YCxCa;ADqCjB;;AAME;EACE,kBAAA;AAHJ;;AAME;EACE,kCC9CY;ED+CZ,sEAAA;AAHJ;;AAME;EACE,yBAAA;EACA,cAAA;EACA,gBAAA;AAHJ","sourcesContent":["@import '../../../../scss/variables';\n.row{\n    display: flex;\n    justify-content: space-around;\n}\n\n/* Styles for the table */\ntable {\n    border-collapse: collapse;\n    width: 100%;\n  }\n  \n \n  table, th, td {\n    border: 0.25px solid black;\n    padding: 0.25px;\n  }\n\n \nmat-card {\n    min-width: 280px;\n    text-align: center;\n    margin: 16px; \n  }\n  \n \n  mat-card-title {\n    background-color: $primary-color;\n    color: $selected-metal;\n  }\n  \n  /* Optional: Style the buttons to be centered */\n  mat-card-actions {\n    justify-content: center;\n    align-items: center;\n    display: flex;\n  }\n  \n  mat-card-content {\n    margin-top: 8px;\n  }\n\n  button[mat-raised-button] {\n    background-color: $primary-color; \n    color: $selected-metal;\n  }\n\n  button[mat-stroked-button] {\n    margin-right: 12px;\n  }\n  \n  button[mat-raised-button]:hover {\n    background-color: $primary-color;  \n    box-shadow: 0 4px 8px rgba(0,0,0,0.24), 0 0 1px rgba(0,0,0,0.24); \n  }\n  \n  button[mat-raised-button][disabled] {\n    background-color: #e0e0e0;  \n    color: #9e9e9e; \n    box-shadow: none; \n  }","$fa-font-path: \"../../node_modules/font-awesome/fonts\";\n\n$background-color: #fff;\n$copyrightbackground-color: #111329;\n$selected-metal: white;\n$disabled-color: #777777;\n$primary-color: rgb(238, 70, 81);\n$primary-hover: rgb(238, 70, 81);\n$secondary-color: #111329;\n$secondary-scolor: #f0ad4e;\n$secondary-hover: #111329;\n$accept-color: #76d0f5;\n$accept-hover: #76d0f5;\n$reject-color: #f32314;\n$reject-hover: #d43f3a;\n$secondary-button-color: #eeeeee;\n\n$body-font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n$button-font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n$error-font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n$primary-font-color: #333333;\n$secondary-font-color: #777777;\n$title-font-size: 3rem;\n$title-font-weight: 400;\n$sub-title-font-size: 1.5rem;\n$sub-title-font-weight: 400;\n$heading-font-size: 2.25rem;\n$body-font-size: 1rem;\n$copyright-font-size: 10px;\n$top-navigation-font-size: 1rem;\n\n//bootstrap\n$spacer: 1rem !default;\n$spacers: (\n\t0: 0,\n\t1: $spacer,\n\t2: calc(\n\t\t$spacer * 2,\n\t),\n\t3: calc(\n\t\t$spacer * 3,\n\t),\n\t4: calc(\n\t\t$spacer * 4,\n\t),\n\t5: calc(\n\t\t$spacer * 5,\n\t),\n\t6: calc(\n\t\t$spacer * 6,\n\t),\n\t7: calc(\n\t\t$spacer * 7,\n\t),\n\t8: calc(\n\t\t$spacer * 8,\n\t),\n\t9: calc(\n\t\t$spacer * 9,\n\t),\n\t10: calc(\n\t\t$spacer * 10,\n\t),\n\t11: calc(\n\t\t$spacer / 5,\n\t),\n\t12: calc(\n\t\t$spacer / 2\n\t)\n) !default;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
